module.exports = __webpack_public_path__ + "static/delivery.3d3a574e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/articles/delivery/delivery.mp4
// module id = 334
// module chunks = 80873460386452